import store from '@/store'
import axios from 'axios'
import {Message} from 'element-ui'

import router from "@/router"

import util from '@/libs/util'
// 数据防篡改
// import CryptoJS from '@/plugin/crypto-js'

// 创建一个错误
function errorCreat(msg, jsonError) {
  const err = new Error(msg)
  errorLog(err)
  throw jsonError
}

//
// function errorCallBack (data){
//   const err = data
//   throw err
//   // return Promise.reject(err)
// }

// 记录和显示错误
function errorLog(err) {
  // 添加到日志
  store.dispatch('d2admin/log/add', {
    type: 'error',
    err,
    info: '数据请求异常'
  })
  //打印到控制台
  if (process.env.NODE_ENV === 'development') {
    util.log.danger('>>>>>> Error >>>>>>')
    console.log(err)
  }
  if (err.message == '对不起，你是黑名单用户，操作被拒绝') {
    Message({
      customClass: 'ajax-error',
      message: err.message,
      type: 'error',
      duration: 3 * 1000
    })
  }else if (err.message == '会话已超时') {
    Message({
      customClass: 'ajax-error',
      message: err.message,
      type: 'error',
      duration: 3 * 1000
    })
    window.sessionStorage.removeItem('userId');
    window.sessionStorage.removeItem('entId');
    window.sessionStorage.removeItem('entState');
    window.sessionStorage.removeItem('userState')
    window.sessionStorage.removeItem('ent');
    window.sessionStorage.removeItem('rights');
  }else if (err.message == '服务器内部错误') {
    Message({
      customClass: 'ajax-error',
      message: err.message,
      type: 'error',
      duration: 3 * 1000
    })
    window.sessionStorage.removeItem('entId');
    window.sessionStorage.removeItem('entState');
    window.sessionStorage.removeItem('userState')
    window.sessionStorage.removeItem('userId');
    window.sessionStorage.removeItem('ent');
    window.sessionStorage.removeItem('rights');
  } else{
    Message({
      showClose: true,
      customClass: 'ajax-error',
      message: err.message,
      type: 'error',
      duration: 3 * 1000
    })
  }
}

// 创建一个 axios 实例
const service = axios.create({
  baseURL: process.env.VUE_APP_API2,
  timeout: 220000 // 请求超时时间
})
// 请求拦截器
service.interceptors.request.use(
  config => {
    // 在请求发送之前做一些处理
    if (!(/^https:\/\/|http:\/\//.test(config.url))) {
      const token = util.cookies.get('token')
      if (token && token !== 'undefined') {
        // 让每个请求携带token-- ['X-Token']为自定义key 请根据实际情况自行修改
        config.headers['X-Token'] = token
      }
      // 在请求头中添加appId字段
      config.headers.appId = 'mkt'

    }
    //获取存储在sessionStroage中的token
    const token = sessionStorage.getItem('token');
    // 如果存在token，则在请求头中添加Authorization字段，并携带token
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    //获取存储在sessionStroage中的lang
    const lang = sessionStorage.getItem('lang');
    // 如果存在lang，则在请求头中添加lang字段，并携带lang
    if (lang) {
      config.headers['lang'] = lang;
    }
    // config.headers['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'
    return config
  },
  error => {
    // 发送失败
    console.log(error)
    Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    if (response.headers['content-disposition']) {
      const filename = response.headers['content-disposition'].split(';')[1].split('=')[1]
      sessionStorage.setItem('filename', decodeURI(filename))
    }
    const dataAxios = response.data
    const {jsonError} = dataAxios
    if (jsonError === undefined) {
      return dataAxios
    } else {
      if (jsonError[0]._exceptionMessageCode == 'role.invalid_user') {
        router.push({
          path: "/login"
        })
      }
      errorCreat(`${dataAxios.jsonError[0]._exceptionMessage}`, dataAxios)
    }
  },
  error => {
    //超时取消请求重新发送
    // var originalRequest = error.config;
    // if(error.code == 'ECONNABORTED' && error.message.indexOf('timeout')!=-1 && !originalRequest._retry){
    //   originalRequest._retry = true
    //   return axios.request(originalRequest);
    // }
    if (error && error.response) {
      if(error.response.data.msg){
        error.message = error.response.data.msg
        switch (error.response.status) {
          case 401:
            router.push({
              path: "/login"
            })
            break
          default:
            break
        }
      }else {
        switch (error.response.status) {
          case 400:
            error.message = '请求错误'
            break
          case 401:
            error.message = '未授权，请登录'
            break
          case 403:
            error.message = '拒绝访问'
            break
          case 404:
            error.message = `请求地址出错: ${error.response.config.url}`
            break
          case 408:
            error.message = '请求超时'
            break
          case 500:
            error.message = '服务器内部错误'
            break
          case 501:
            error.message = '服务未实现'
            break
          case 502:
            error.message = '网关错误'
            break
          case 503:
            error.message = '服务不可用'
            break
          case 504:
            error.message = '网关超时'
            break
          case 505:
            error.message = 'HTTP版本不受支持'
            break
          default:
            break
        }
      }

    }
    errorLog(error)
    return Promise.reject(error)
  }
)

export default service

// 封装方法 get/post
/**
 * get请求方法
 * @param {string} url 请求的url地址
 * @param {object} config 针对于当前的请求添加的额外请求头信息 {headers:{token:'xxx'}}
 * @returns Promise<any>
 */
export const get = (url, config = {}) => service.get(url, config)

/**
 * post请求方法
 * @param {string} url 请求的url地址
 * @param {object} data 请求体数数据 {name:'aa'}
 * @param {object} config 针对于当前的请求添加的额外请求头信息 {headers:{token:'xxx'}}
 * @returns Promise<any>
 */
export const post = (url, data = {}, config = {}) => service.post(url, data, config)


/**
 * delete请求方法
 * @param {string} url 请求的url地址
 * @param {object} config 针对于当前的请求添加的额外请求头信息 {headers:{token:'xxx'}}
 * @returns Promise<any>74045B13.jpg
 */
export const del= (url, config = {}) => service.delete(url, config)

/**
 * put请求方法
 * @param {string} url 请求的url地址
 * @param {object} data 请求体数据 {name:'aa'}
 * @param {object} config 针对于当前的请求添加的额外请求头信息 {headers:{token:'xxx'}}
 * @returns Promise<any>
 */
export const put = (url,data={}, config = {}) => service.put(url,data, config)
